import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  //Button,
  //TextField,
  Container,
  Paper,
  Divider,
  Button,
} from '@mui/material';
import Seo from './Seo';

const MarriageMinistry = () => {
  //   const [contactForm, setContactForm] = useState({
  //     name: '',
  //     email: '',
  //     message: '',
  //   });

  //   const handleFormChange = (
  //     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  //   ) => {
  //     const { name, value } = e.target;
  //     setContactForm((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   };

  //   const handleSubmit = (e: React.FormEvent) => {
  //     e.preventDefault();
  //     // Add form submission logic here
  //     console.log('Form submitted:', contactForm);
  //     // Reset form
  //     setContactForm({ name: '', email: '', message: '' });
  //     alert('Thank you for your message! We will get back to you soon.');
  //   };

  return (
    <Container maxWidth="lg">
      <Seo
        title="Marriage Ministry"
        description="The Marriage Ministry at New Mt. Zion Missionary Baptist Church in Lakeland, FL — strengthening marriages through faith and fellowship."
        path="/marriage"
      />
      {/* Hero Section */}
      <Box
        sx={{
          mt: 2,
          textAlign: 'center',
          py: 3,
          mb: 4,
          backgroundImage: `url(${require('../images/ministries/marriage2.jpg')})`,
          // backgroundImage: `url('https://t4.ftcdn.net/jpg/02/40/69/37/360_F_240693748_dJg2rJiXg3bolGvsPEbB7zIKj6husdlM.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          gutterBottom
          sx={{
            borderRadius: 2,
            textShadow: '2px 2px 4px rgba(0, 0, 0)',
          }}
        >
          Marriage Ministry
        </Typography>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            borderRadius: 2,
            textShadow: '2px 2px 4px rgba(0, 0, 0)',
            mb: 4,
          }}
        >
          Nurturing marriages to flourish according to God&apos;s perfect design
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            href="https://forms.gle/du7CtAEdqhsZGyqz6"
            target="_blank"
          >
            Register
          </Button>
          {/* 
          <Button
            variant="contained"
            color="secondary"
            size="large"
            href="https://forms.gle/du7CtAEdqhsZGyqz6"
            target="_blank"
          >
            Fill Survey
          </Button> */}
        </Box>
      </Box>

      {/* Mission Statement */}
      <Paper elevation={2} sx={{ p: 4, mb: 6, textAlign: 'center' }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Our Mission
        </Typography>
        <Typography variant="body1" paragraph>
          We meet on a regular basis as a group, to discuss how to apply
          biblical concepts to nurture our marriages. Open to married and
          engaged couples, as well as individuals interested in marriage.
        </Typography>
      </Paper>

      {/* Ministry Events */}
      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ textAlign: 'center', mb: 4 }}
        >
          Upcoming Events
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={4}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image="https://upload.wikimedia.org/wikipedia/commons/f/fd/US_Navy_090819-N-2259V-119_A_Sailor_releases_the_ball_down_the_lane_at_a_bowling_competition_during_the_2009_San_Diego_Surface_Line_Week.jpg?utm_source=en.wikipedia.org&utm_campaign=index&utm_content=original"
                //image="https://www.shutterstock.com/image-photo/home-relax-black-couple-on-600nw-2382456483.jpg"
                alt="Marriage Workshop"
                sx={{ backgroundColor: '#f5f5f5' }} // Placeholder color if image doesn't load
              />
              <CardContent>
                <Typography variant="h6" component="h3">
                  Bowling
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Nov 21st, 2026, 6pm - Bowling
                </Typography>
                {/* <Typography variant="body1">
              Join us for a half-day workshop focused on communication
              skills and conflict resolution.
            </Typography> */}
                <Button
                  sx={{ mt: 2 }}
                  variant="outlined"
                  size="small"
                  href="https://forms.gle/MzDLTScKsP6aG26k6"
                  //href="https://forms.gle/du7CtAEdqhsZGyqz6"
                  target="_blank"
                >
                  Register
                </Button>
              </CardContent>
            </Card>
          </Grid>
          {/* <Grid item xs={12} md={4}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image="https://www.ncl.com/sites/default/files/NCL_Escape_mobile.jpg"
                alt="Marriage Workshop"
                sx={{ backgroundColor: '#f5f5f5' }} // Placeholder color if image doesn't load
              />
              <CardContent>
                <Typography variant="h6" component="h3">
                  Group Cruise
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Summer 2026
                  <br />
                  June 8th - 12th, 2026
                </Typography>
                <Button
                  sx={{ mt: 2 }}
                  variant="outlined"
                  size="small"
                  href="/cruise2026"
                  target="_blank"
                >
                  Join
                </Button>
              </CardContent>
            </Card>
          </Grid> */}
        </Grid>
      </Box>

      {/* Lessons Section */}
      <Paper elevation={3} sx={{ p: 4, mb: 6, textAlign: 'center' }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Marriage Lessons
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          Explore our collection of biblical marriage lessons designed to
          strengthen your relationship and help you grow together as a couple
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          href="/marriage/lessons"
          sx={{ mr: 2 }}
        >
          View All Lessons
        </Button>
      </Paper>
      {/* Resources Section */}
      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ textAlign: 'center', mb: 4 }}
        >
          Marriage Resources
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <Paper elevation={1} sx={{ p: 3, height: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Recommended Resources
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <ul>
                <li>
                  {' '}
                  <a
                    href="https://pages.rightnowmedia.org/promo/love-talk"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {' '}
                    Love Talk by Les & Leslie Parrott
                  </a>{' '}
                </li>
                <li>
                  {' '}
                  <a
                    href="https://assessments.focusonthefamily.com/s3/couples-assessment"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {' '}
                    Marriage Assesment
                  </a>{' '}
                </li>
              </ul>
            </Paper>
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <Paper elevation={1} sx={{ p: 3, height: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Marriage Counseling
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body1" paragraph>
                We offer confidential Christian counseling for couples at all
                stages of marriage.
              </Typography>
              <Button variant="contained" color="secondary" size="small">
                Schedule a Session
              </Button>
            </Paper>
          </Grid> */}
        </Grid>
      </Box>

      {/* Leadership Team */}
      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ textAlign: 'center', mb: 4, mt: 10 }}
        >
          Ministry Leadership
        </Typography>
        <Grid container spacing={4} justifyContent="center" sx={{}}>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ textAlign: 'center' }}>
              <CardMedia
                component="img"
                height="300"
                image="https://firebasestorage.googleapis.com/v0/b/nmzlakeland-a8568.appspot.com/o/ministries%2F20240601_151516.jpg?alt=media&token=fe5a27fe-f529-4f2b-8b0f-bc2a041a9d98"
                alt="Ministry Leaders"
                sx={{ backgroundColor: '#f5f5f5' }}
              />
              <CardContent>
                <Typography variant="h6">Ruky & Chase Ojameruaye</Typography>
                <Typography variant="body2" color="text.secondary">
                  Ministry Leaders
                </Typography>
                <Typography variant="body2">
                  Contact:{' '}
                  <a href="mailto:rukychase@gmail.com">rukychase@gmail.com</a>
                </Typography>
                {/* <Typography variant="body1" sx={{ mt: 1 }}>
                  Married for 25 years with a passion for helping couples build
                  Christ-centered marriages.
                </Typography> */}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Contact Form */}
      {/* <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ textAlign: 'center', mb: 4 }}
        >
          Contact Us
        </Typography>
        <Paper elevation={3} sx={{ p: 4 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Name"
                  name="name"
                  value={contactForm.name}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={contactForm.email}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Message"
                  name="message"
                  multiline
                  rows={4}
                  value={contactForm.message}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary">
                  Send Message
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box> */}
    </Container>
  );
};

export default MarriageMinistry;
